'use strict';

var theme_index = require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');



exports.theme = theme_index.theme;
//# sourceMappingURL=index.js.map
